var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2514 17.3851L12.2605 17.3915C13.0476 17.8926 13.982 18.1102 14.9095 18.0084C15.837 17.9065 16.7019 17.4913 17.3615 16.8313L17.9344 16.2584C18.0614 16.1315 18.1621 15.9808 18.2308 15.815C18.2995 15.6492 18.3349 15.4714 18.3349 15.2919C18.3349 15.1124 18.2995 14.9347 18.2308 14.7688C18.1621 14.603 18.0614 14.4524 17.9344 14.3255L15.5178 11.9107C15.3909 11.7838 15.2403 11.683 15.0745 11.6143C14.9086 11.5456 14.7309 11.5102 14.5514 11.5102C14.3719 11.5102 14.1941 11.5456 14.0283 11.6143C13.8625 11.683 13.7118 11.7838 13.5849 11.9107C13.3287 12.1669 12.9813 12.3108 12.619 12.3108C12.2567 12.3108 11.9092 12.1669 11.653 11.9107L7.78901 8.04586C7.53287 7.78963 7.38897 7.44217 7.38897 7.07987C7.38897 6.71757 7.53287 6.3701 7.78901 6.11388C7.91598 5.987 8.0167 5.83633 8.08542 5.67051C8.15414 5.50468 8.18951 5.32694 8.18951 5.14744C8.18951 4.96794 8.15414 4.79019 8.08542 4.62437C8.0167 4.45854 7.91598 4.30788 7.78901 4.18099L5.37336 1.76625C5.11714 1.51011 4.76967 1.36621 4.40737 1.36621C4.04507 1.36621 3.69761 1.51011 3.44138 1.76625L2.86753 2.33919C2.20768 2.99883 1.79262 3.86385 1.69093 4.79131C1.58924 5.71878 1.80701 6.65318 2.30825 7.44012L2.31371 7.44923C4.9609 11.3658 8.33434 14.7386 12.2514 17.3851V17.3851Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.a0ae2c1f025f772bbf3a62e6c96e6d3b.svg";
export { ForwardRef as ReactComponent };